<template>
  <div>
    <v-row class="main_header" style="margin-bottom:0px">
      <v-col class="pl-4" xs12 :cols="9" style="color: #1B3A57;margin-top:10px">{{headerTitle}}
        <div class="return-class" v-if="returnCondition == true">
          <router-link style="font-size: 14px; color: #0357D0;" :to="routerLink">{{ routerLinkText }}</router-link>
          <span v-if="showImage">
            <img class="mt-3 image-align" src="@/assets/images/icons/expand_more.svg" width="7" height="10" />
          </span>
          <span>{{ componentName }}</span>
        </div> 
      </v-col>
      <v-col justify="center" xs2 :cols="3">
        <v-menu :close-on-content-click="false" :nudge-width="100" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <span style="margin-right: 5px;" class="pull-right">
              <img
                align="center"
                src="@/assets/images/icons/Ellipse 2.png"
                height="32"
                width="32"
                v-bind="attrs"
                v-on="on"
              />
            </span>
          </template>

            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title
                    style="text-align:right;  font-size: 18px;  color: #4f4f4f;"
                  >Croma</v-list-item-title>
                  <v-list-item-subtitle style="text-align:right">{{this.user.email}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <a class="logout-text" text @click="signOut">Logout</a>
            </v-card-actions>
        </v-menu>
        <span style="margin-right: 20px;" class="pull-right">
          <img align="center" src="@/assets/images/icons/questions.png" height="20" width="20" />
        </span>
        <span style="margin-right: 20px;" class="pull-right">
          <v-autocomplete
            v-model="current_warehouse"
            :items="menu_items"
            item-text="code"
            @change="changeWarehouse"
            item-value="id"
            outlined
            dense
            color="primary"
            :label="menu_items[0].code"
          ></v-autocomplete>
        </span>
      </v-col>
    </v-row>
  </div>
</template>
<style >
.client-name {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  color: #4f4f4f;
}

.v-application a {
  color: #333333;
  font-weight: bold;
  font-size: 12px;
}
.v-application .pl-4 {
    padding-left: 23px!important;
}
.v-menu__content {
    background-color: #ffffff;
}
.image-align{
    margin-bottom: 10px;
    margin-left: 6px;
    margin-right: 6px;
}
.return-class{
    font-size: 14px !important;
}
</style>

<script>
export default {
  // props: ["headerTitle"],
  props: {
    headerTitle: {
      type: String,
      required: true,
    },
    routerLink: {
      type: Object,
      default: () => ({ name: '' }),
    },
    routerLinkText: {
      type: String,
      default: '',
    },
    returnCondition: {
      type: Boolean,
      default: true,
    },
    componentName: {},
  },
  computed: {
    showImage() {
      return this.routerLinkText && this.componentName;
    },
  },
  data() {
    return {
      files: [],
      user:"",
      attachmentLabel: "Attachment Documents",
      menu_items: [],
      current_warehouse: ''
    };
  },
  created() {
    this.user = this.$store.state.currentUser;
    this.menu_items = this.$store.state.currentUser.available_distribution_centers
    this.current_warehouse = this.$store.state.current_warehouse
  },
  components: {},
  methods: {
    fileAttachment(event) {
      let attachmentObj = {
        attachedfFiles: this.files,
      };
      this.$emit("clicked", attachmentObj);
    },
    signOut() {
      this.$http.secured
        .delete("/api/v1/logout")
        .then((response) => {
          this.$store.commit("unsetCurrentUser");
          this.$store.commit("unsetSelectedLot");
          this.$store.commit("setCurrentWarehouse", {distribution_id: ''})
          this.$router.replace("/");
          this.$toast.success("Logout successful");
        })
        .catch((error) => {
          this.$toast.error("Error in logging out");
        });
    },

    changeWarehouse(){
      if (this.current_warehouse == 0){
        this.$store.commit("setCurrentWarehouse", {distribution_id: ''})
      }else{
        this.$store.commit("setCurrentWarehouse", {distribution_id: this.current_warehouse})
      }
      this.$router.go()
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/commoncomponents/HeaderComponent.vue